<script setup lang="ts">
import { fetchTopicJson } from './apis/api';
import type { CarouselNews } from './components/TopicCarousel.vue';
import useWxShareStore from './store/wxShare';
import { browerVersion, formatNewsUrlParams, initYoumeng } from './utils';
import articleUpload from '@/assets/images/article-upload.png';
import artsUpload from '@/assets/images/arts-upload.png';
import classImage from '@/assets/images/class.png';
import newsImage from '@/assets/images/news.png';
import qAndA from '@/assets/images/qAndA.png';
import studyImage from '@/assets/images/study.png';
import worksImage from '@/assets/images/works.png';

const bottomImageList = ref([
  {
    name: '作文投稿',
    image: articleUpload,
    link: 'https://www.gz-cmc.com/contentapi/server/content/shortlink?id=ea0016becd2b82fbfa6f7a76c48e61ec',
  },
  {
    name: '美术投稿',
    image: artsUpload,
    link: 'https://www.gz-cmc.com/contentapi/server/content/shortlink?id=c466d41ed166f23b5883cde1afeeb791',
  },
  {
    name: '资讯',
    image: newsImage,
    link: 'https://huacheng.gz-cmc.com/topic/2024/04/03/08ecb0b77e4f4878a4f82d77328d47e9.html',
  },
  {
    name: '答疑',
    image: qAndA,
    link: 'https://huacheng.gz-cmc.com/topic/2024/04/03/a02b406115cd41009e645222497abf55.html',
  },
  {
    name: '粤韵名师大讲堂',
    image: classImage,
    link: 'https://huacheng.gz-cmc.com/topic/2024/04/03/336a7bb91b534a1898f62754aebcff11.html',
    isLong: true,
  },
  {
    name: '往届优秀作品集',
    image: worksImage,
    link: 'https://wxapp.gz-cmc.com/wxapp/2024/h5/yueyun/pre-work.pdf',
    isLong: true,
  },
  {
    name: '粤韵研学',
    image: studyImage,
    link: 'https://huacheng.gz-cmc.com/topic/2024/04/03/3f385f709113402cbdf6b27c118fa57b.html',
  },
]);
const wxShareStore = useWxShareStore();
const version = browerVersion();
const { height: windowHeight } = useWindowSize();
const containerWidth = computed(() => {
  if (version.mobile) {
    return '100vw';
  }
  return `${(windowHeight.value / 1465) * 750}px`;
});

const topicUrl =
  'https://huacheng.gz-cmc.com/topic/2024/04/03/08ecb0b77e4f4878a4f82d77328d47e9.html';
const topicCarouselList = ref<CarouselNews[]>([]);
const getCarouselList = () => {
  const topicParams = formatNewsUrlParams(topicUrl);
  if (typeof topicParams === 'object') {
    fetchTopicJson(
      topicParams.year,
      topicParams.month,
      topicParams.date,
      topicParams.newsId,
    ).then((res) => {
      const { carouselList } = res;
      topicCarouselList.value = carouselList.map((item) => ({
        title: item.data.title,
        image: item.carouselImgUrl,
        id: item.id,
        url: item.data.url,
      }));
    });
  }
};

onMounted(() => {
  getCarouselList();
  initYoumeng();
  wxShareStore.initWxShare();
});
</script>

<template>
  <section class="main-container">
    <div class="header-logo-box">
      <img
        src="@/assets/images/header-logo.png"
        class="header-logo"
        alt="顶部logo"
      />
    </div>
    <div class="theme-text-box">
      <img
        class="theme-text"
        src="@/assets/images/theme-text.png"
        alt="粤韵杯2024 广州市中小学生作文与美术主题大赛 英雄花开英雄城 继往开来"
      />
    </div>
    <topic-carousel
      v-if="topicCarouselList.length"
      :carousel-list="topicCarouselList"
    />
    <div class="bottom-btn-list">
      <div
        v-for="item in bottomImageList"
        :key="item.name"
        class="bottom-btn-box"
      >
        <a class="bottom-btn-a" :href="item.link" target="_blank">
          <img
            :src="item.image"
            :alt="item.name"
            class="bottom-btn-image"
            :class="{ 'bottom-btn-long-image': item.isLong }"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  width: v-bind('containerWidth');
  height: 100vh;
  margin: 0 auto;
  overflow-y: auto;
  background-color: rgb(254 54 92);
  background-image: url('@/assets/images/bg.png');
  background-size: 100%;

  .header-logo-box {
    width: 100%;
    padding: 15px 15px 0 0;
    text-align: right;

    .header-logo {
      width: 55%;
    }
  }

  .theme-text-box {
    width: 100%;
    padding: 0 0 0 15px;

    .theme-text {
      width: 70%;
    }
  }

  .bottom-btn-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 20px;
    justify-content: center;
    padding-bottom: 60px;

    .bottom-btn-box {
      width: 35%;
      text-align: center;

      .bottom-btn-a {
        display: inline-block;
        width: 100%;

        .bottom-btn-image {
          width: 60%;
        }

        .bottom-btn-long-image {
          width: 100%;
        }
      }
    }
  }
}
</style>
